"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVG = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _core = require("./core");

var _AspectRatio = require("./AspectRatio");

var SVG = function SVG(_ref) {
  var svg = _ref.svg,
      fill = _ref.fill,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svg", "fill"]);
  return _react.default.createElement(_AspectRatio.AspectRatio, props, _react.default.createElement(_core.SVG, {
    as: svg,
    fill: fill,
    width: "100%",
    height: "100%"
  }));
};

exports.SVG = SVG;